import React, { useState, useEffect, useMemo } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { USERS, PAGE_LIMIT } from "helpers/viewContent";
import {
  FORMAT_TEXT,
  DATE_FORMAT,
  FORMAT_TEXT_VALUE,
  DATE_FORMAT_TIME,
  export_csv_fields_data,
} from "helpers/common";
import ReactPagination from "components/shared/ReactPagination";
import { DELETE_ALERT } from "helpers/constantsMessage";
import { PRODUCT_IMG } from "utils/constant";
import ContentLoader_ from "helpers/ContentLoader_";
import { debounce } from "lodash";
import { CSVLink } from "react-csv";

//imported
import * as Path from "routes/paths";
import * as actions from "store/actions/index.js";
import {
  getList_,
  getWithoutPaginationList_,
  deleteData_,
  updateData_,
} from "store/services/commonService";
import FilterPop from "./FilterPop";

const Listing = ({ dispatch, itemsCountPerPage, totalItemsCount, loader }) => {
  //pagination
  const [activePage, setActivePage] = useState(1);
  const [listing, setListing] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [oepnFilterVal, setOepnFilterVal] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [permissionsArray, setPermissionsArray] = useState([]);

  const [filter, setFilter] = useState({
    page: activePage,
    limit: PAGE_LIMIT,
    sort_by: "",
    yearly_data: "",
    filter_gender: "",
    filter_age: "",
    date_val: "",
    search_string: "",
  });

  const fetchData = async () => {
    try {
      let query = {
        ...filter,
        url: "user/list",
        common: false,
      };
      setIsLoading(true);
      dispatch(actions.persist_store({ loader: false }));
      dispatch(actions.persist_store({ editIdProps: null }));
      let res = await dispatch(getList_(query));
      setListing(res?.body?.data);
      // setCsvData(res?.body?.data);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

  const fetchDataUser = async () => {
    try {
      let query = {
        url: "basic_setting/list",
        module_name: "users",
        type: "setting",
      };
      let res = await dispatch(getWithoutPaginationList_(query));
      setPermissionsArray(res?.body);
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

  useEffect(() => {
    fetchDataUser();
  }, []);

  //filter
  let listToDisplay = listing;
  if (filter?.search_string !== "") {
    const searchTerm = filter?.search_string.toLowerCase();
    listToDisplay = listing.filter((list) => {
      const itemName = list?.name?.toLowerCase();
      const itemEmail = list?.email?.toLowerCase();
      const itemPhone = list?.phone?.toLowerCase();
      const itemNational = list?.nationality?.toLowerCase();
      return (
        itemName?.includes(searchTerm) ||
        itemEmail?.includes(searchTerm) ||
        itemPhone?.includes(searchTerm) ||
        itemNational?.includes(searchTerm)
      );
    });
  }
  const handleSearchChange = (event) => {
    const inputValue = event.target.value;
    setFilter({
      ...filter,
      search_string: inputValue,
    });
  };
  const debouncedFetchData = useMemo(() => {
    return debounce(handleSearchChange, 500);
  }, []);

  useEffect(() => {
    return () => {
      debouncedFetchData.cancel();
    };
  }, []);

  useEffect(() => {
    fetchData();
  }, [filter?.page, filter?.search_string, , searchValue]);

  //pagination
const handlePageChange = (page) => {
  setActivePage(page);

  setFilter((prev) => ({
    ...prev,
    page,
  }));

  window.scrollTo(0, 0);
};
  //delete
  const deleteUsers_ = async (id) => {
    try {
      await DELETE_ALERT().then(async (willDelete) => {
        if (willDelete) {
          try {
            let query = {
              url: "user/delete",
              id: id,
            };
            await dispatch(deleteData_(query)).then(() => {
              fetchData();
            });
          } catch (err) {
            console.log(err);
          }
        }
      });
    } catch (err) {
      console.log(err);
      dispatch(actions.persist_store({ loader: false }));
    }
  };
  //update status
  const updateStatus_ = async (data) => {
    try {
      let query = {
        url: `user/update_status`,
        id: data?.id,
        status: data?.status === "1" ? "0" : "1",
      };
      await dispatch(updateData_(query));
      fetchData();
    } catch (err) {
      console.log(err);
    }
  };
  const clearSerchFilter = () => {
    setFilter({
      ...filter,
      search_string: "",
    });
    fetchData();
  };

  const openFilterModal = () => {
    setOepnFilterVal(true);
  };
  const closeFilterModal = () => {
    setOepnFilterVal(false);
    setFilter({
      page: activePage,
      limit: PAGE_LIMIT,
      sort_by: "",
      yearly_data: "",
      filter_gender: "",
      filter_age: "",
      date_val: "",
      search_string: "",
    });
  };
  //export data
  const generateExcel = async () => {
    try {
      let query = {
        url: "user/list",
        common: false,
      };
      let res = await dispatch(getList_(query));
      if (res?.body?.data) {
        let result = await export_csv_fields_data(res?.body?.data);
        setExcelData(result);
      } else {
        console.error("No data received for Excel export");
      }
    } catch (err) { }
  };
  useEffect(() => {
    generateExcel();
  }, []);
  return (
    <>
      <Helmet title={USERS.CURRENT_MODULE} />
      <div className="page-header">
        <h3 className="page-title">
          <span className="page-title-icon bg-gradient-primary text-white me-2">
            <i className="mdi mdi-account-multiple menu-icon"></i>
          </span>{" "}
          {USERS.CURRENT_MODULE}
        </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={Path.users}>{USERS.CURRENT_MODULE}</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Listing
            </li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-10">
                  <h4 className="card-title">Listing</h4>
                </div>
                {/* <div className="col-md-2">
                        <Link to={Path.basic_setting} title="Modify Grid ">
                          <button type="button" class="btn btn-lg btn-gradient-info">
                            {" "}
                            Modify Grid 
                          </button>
                        </Link>
                    </div> */}
              </div>
              <br />
              <div className="d-flex align-items-center justify-content-between">
                <div className="left d-flex align-itmes-center">
                  <Link
                    to="#"
                    onClick={() => openFilterModal()}
                    title="Filter"
                    className="me-2"
                  >
                    <button type="button" class="btn btn-lg btn-gradient-info">
                      {" "}
                      Apply Filter
                    </button>
                  </Link>
                  <Link
                    to="#"
                    onClick={clearSerchFilter}
                    title="Clear Filter"
                    className="me-2"
                  >
                    <button
                      type="button"
                      class="btn btn-lg btn-gradient-danger"
                    >
                      {" "}
                      Clear Filter
                    </button>
                  </Link>
                  <Link
                    to={Path.basic_setting}
                    title="Modify Grid "
                    className="me-2"
                  >
                    <button type="button" class="btn btn-lg btn-gradient-info">
                      {" "}
                      Modify Grid
                    </button>
                  </Link>
                </div>
                <div className="right">
                  <div class="add-items d-flex">
                    <input
                      className="form-control"
                      autoComplete="chrome-off"
                      name="searchUnique"
                      type="text"
                      placeholder="Search name/email/phone/nationality"
                      value={filter?.search_string}
                      onChange={(e) => handleSearchChange(e)}
                    />
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm"
                      id="add-task"
                      onClick={clearSerchFilter}
                    >
                      <i class="mdi mdi-close-circle"></i>
                    </button>
                    <Link to={Path.user_add} title="Add">
                      <button
                        type="button"
                        className="btn btn-lg btn-gradient-primary"
                      >
                        {" "}
                        + Add
                      </button>
                    </Link>
                    &nbsp;&nbsp;
                    <CSVLink
                      data={excelData}
                      filename={`exported_data_${Date.now()}.csv`}
                      className="btn btn-lg btn-gradient-danger"
                      target="_blank"
                      title="Csv"
                    >
                      Export CSV
                    </CSVLink>
                  </div>
                </div>
              </div>
              <div class="table-responsive actionSticky">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      {permissionsArray.map((fieldA) => {
                        if (fieldA.status === "1") {
                          const matchingFieldB = listing.find(
                            (fieldB) =>
                              fieldB[fieldA.field] && fieldB.status === "1"
                          );
                          if (matchingFieldB) {
                            return <th>{FORMAT_TEXT_VALUE(fieldA.field)}</th>;
                          }
                        }
                      })}
                      <th> Status </th>
                      <th> Created At </th>
                      <th> Action </th>
                    </tr>
                  </thead>
                  {isLoading ? (
                    <div className="loader-class">
                      afsdadf
                    </div>
                  ) : (
                    <tbody>
                      {listToDisplay.length > 0 &&
                        listToDisplay.map((list, i) => {
                          return (
                            <tr key={i}>
                              {permissionsArray.map((fieldA) => {
                                if (fieldA.status === "1") {
                                  const matchingFieldB = listing.find(
                                    (fieldB) =>
                                      fieldB[fieldA.field] &&
                                      fieldB.status === "1"
                                  );
                                  if (matchingFieldB) {
                                    if (fieldA.field === "image") {
                                      return (
                                        <td>
                                          <a
                                            href={
                                              list?.[fieldA.field]
                                                ? `${list?.[fieldA.field]}`
                                                : "#"
                                            }
                                            target="_blank"
                                          >
                                            <img
                                              src={
                                                list?.[fieldA.field]
                                                  ? `${list?.[fieldA.field]}`
                                                  : PRODUCT_IMG
                                              }
                                              className="custom-img"
                                            />
                                          </a>
                                        </td>
                                      );
                                    } else if (
                                      fieldA.field === "name" ||
                                      fieldA.field === "last_name" ||
                                      fieldA.field === "email" ||
                                      fieldA.field === "nationality" ||
                                      fieldA.field === "location" ||
                                      fieldA.field === "player_style" ||
                                      fieldA.field === "academy_name" ||
                                      fieldA.field === "academy_description" ||
                                      fieldA.field === "state" ||
                                      fieldA.field === "city" ||
                                      fieldA.field === "home_court_address"
                                    ) {
                                      return (
                                        <td className="py-1">
                                          {list[fieldA.field]
                                            ? FORMAT_TEXT(list[fieldA.field])
                                            : "N/A"}
                                        </td>
                                      );
                                    } else if (
                                      fieldA.field === "gender" ||
                                      fieldA.field === "opponent_gender"
                                    ) {
                                      return (
                                        <td className="py-1">
                                          {list[fieldA.field]
                                            ? list[fieldA.field] === "1"
                                              ? "Male"
                                              : list[fieldA.field] === "2"
                                                ? "Female"
                                                : list[fieldA.field] === "3"
                                                  ? "Other"
                                                  : "N/A"
                                            : "N/A"}{" "}
                                        </td>
                                      );
                                    } else if (fieldA.field === "birth_date") {
                                      return (
                                        <td className="py-1">
                                          {list[fieldA.field]
                                            ? DATE_FORMAT(list[fieldA.field])
                                            : "N/A"}
                                        </td>
                                      );
                                    } else if (
                                      fieldA.field === "platform_joining_type"
                                    ) {
                                      return (
                                        <td className="py-1">
                                          {list[fieldA.field]
                                            ? list[fieldA.field] === "1"
                                              ? "Player"
                                              : list[fieldA.field] === "2"
                                                ? "Parent"
                                                : "N/A"
                                            : "N/A"}{" "}
                                        </td>
                                      );
                                    } else {
                                      // Render other fields
                                      return (
                                        <td>
                                          {list[fieldA.field]
                                            ? list[fieldA.field]
                                            : "N/A"}
                                        </td>
                                      );
                                    }
                                  }
                                }
                              })}
                              <td onClick={() => updateStatus_(list)}>
                                <label
                                  style={{ cursor: "pointer" }}
                                  className={`badge badge-gradient-${list?.status == 1 ? "success" : "danger"
                                    }`}
                                >
                                  {list?.status == 1 ? "Block" : "Unblock"}
                                </label>
                              </td>
                              <td>
                                {list?.created_at
                                  ? DATE_FORMAT_TIME(list?.created_at)
                                  : "N/A"}
                              </td>
                              <td>
                                <Link to={`${Path.user_edit}/${list?.id}`}>
                                  <label
                                    class="btn btn-sm btn btn-gradient-warning"
                                    style={{ cursor: "pointer" }}
                                    title="Edit"
                                  >
                                    <i className="mdi mdi-grease-pencil"></i>
                                  </label>
                                </Link>
                                &nbsp;&nbsp;
                                <Link to={`${Path.userview}/${list?.id}`}>
                                  <label
                                    className="btn btn-sm btn btn-gradient-info"
                                    style={{ cursor: "pointer" }}
                                    title="View"
                                  >
                                    <i className="mdi mdi-eye"></i>
                                  </label>
                                </Link>
                                &nbsp;&nbsp;
                                <label
                                  className="btn btn-sm btn btn-gradient-danger"
                                  style={{ cursor: "pointer" }}
                                  title="Delete"
                                  onClick={() => deleteUsers_(list?.id)}
                                >
                                  <i className="mdi mdi-delete"></i>
                                </label>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  )}
                </table>
              </div>
              {listing.length > 0 && (
                <div className="pagination-box-review">
                  <ReactPagination
                    activePage={activePage}
                    itemsCountPerPage={itemsCountPerPage}
                    totalItemsCount={totalItemsCount}
                    handlePageChange={handlePageChange}
                  />
                </div>
              )}
              {!isLoading && listing.length == 0 && (
                <div className="row">
                  <div className="col-md-6 pt-5">
                    <span>No data found...</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <FilterPop
        oepnFilterVal={oepnFilterVal}
        closeFilterModal={closeFilterModal}
        filter={filter}
        setFilter={setFilter}
        setListing={setListing}
        dispatch={dispatch}
        setOepnFilterVal={setOepnFilterVal}
        activePage={activePage}
        limit={PAGE_LIMIT}
      />
    </>
  );
};

const mapStateToPros = (state) => {
  return {
    itemsCountPerPage: state.Common.itemsCountPerPage,
    totalItemsCount: state.Common.totalItemsCount,
    loader: state.Common.loader,
  };
};
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(Listing);
